// Small menus built on Foundation dropdowns, marked data-menu-dropdown (e.g. a collection's ⋯ View options menu).
// Foundation opens and closes them by click or tap (never hover), sets aria-expanded and moves focus into them; this
// adds what it doesn't do:
// - Escape closes the open one, and focus moving out of it closes it too.
// - They stay on screen and under their button: Foundation lines a menu's left edge up with its button even when that
//   runs it off the right edge of the page (and on small screens stretches it across the page), so such a menu lines
//   its right edge up with the button's instead, within a small margin of the page's edges, arrow under the button.

var MARGIN = 8;

function keepOnScreen(menu, toggle) {
  // On small screens Foundation stretches the menu across the page (width 95%, max-width none); keep the stylesheet's
  // max-width instead, so a short menu stays menu-sized
  menu.style.maxWidth = '';

  var viewport = document.documentElement.clientWidth;
  var menuRect = menu.getBoundingClientRect();
  var toggleRect = toggle.getBoundingClientRect();
  var toggleCenter = toggleRect.left + toggleRect.width / 2;
  var left = menuRect.left;
  // Running off the page, or not under its button: line its right edge up with the button's instead, then keep it
  // within the page either way
  if (left + menuRect.width > viewport - MARGIN || toggleCenter < left || toggleCenter > left + menuRect.width) {
    left = toggleRect.right - menuRect.width;
  }
  left = Math.max(MARGIN, Math.min(left, viewport - MARGIN - menuRect.width));

  if (left !== menuRect.left) {
    menu.style.left = (parseFloat(window.getComputedStyle(menu).left) + left - menuRect.left) + 'px';
  }
  menu.style.setProperty('--arrow-center', (toggleRect.left + toggleRect.width / 2 - left) + 'px');
}

// Foundation positions a dropdown with its css() each time it opens and when the window is resized
(function(dropdown) {
  var css = dropdown.css;
  dropdown.css = function(menu, target) {
    var result = css.apply(this, arguments);
    if (menu.is('[data-menu-dropdown]') && target && target[0]) { keepOnScreen(menu[0], target[0]); }
    return result;
  };
})(Foundation.libs.dropdown);

function toggleFor(menu) {
  return document.querySelector('[data-dropdown="' + menu.id + '"]');
}

function within(menu, element) {
  var toggle = toggleFor(menu);
  return !!element && (menu.contains(element) || (!!toggle && toggle.contains(element)));
}

// Escape closes the open menu. Focus goes back to its button only if it was in the menu or on the button, so pressing
// Escape elsewhere (e.g. in the search box) still does what it would there.
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape' && e.key !== 'Esc') { return; }

  var menu = document.querySelector('[data-dropdown-content][data-menu-dropdown].open');
  if (!menu) { return; }

  var hadFocus = within(menu, document.activeElement);
  Foundation.libs.dropdown.close($(menu));
  if (hadFocus) {
    toggleFor(menu).focus();
    e.preventDefault();
  }
});

// Tabbing (or otherwise moving focus) out of an open menu and its button closes it, rather than leaving it open over
// the page. Focus going nowhere in particular (a tap on plain text, the window losing focus) leaves it be: Foundation
// already closes it on a click or tap outside.
document.addEventListener('focusout', function(e) {
  var menu = document.querySelector('[data-dropdown-content][data-menu-dropdown].open');
  if (!menu || !within(menu, e.target) || !e.relatedTarget || within(menu, e.relatedTarget)) { return; }

  Foundation.libs.dropdown.close($(menu));
});
